import { required } from 'vuelidate/lib/validators';
import { EFieldNames } from '@shared/models/Enums/EFieldNames';
import { FormFieldModel } from '@shared/models/LoginModels/FormFieldModel';

export interface StudentLoginModel {
  [EFieldNames.UserName]: string;
  [EFieldNames.Password]: string;
}

export const studentLoginModel: StudentLoginModel = {
  [EFieldNames.UserName]: '',
  [EFieldNames.Password]: '',
};

export const studentLoginFields: { [key: string]: FormFieldModel } = {
  [EFieldNames.UserName]: {
    label: 'User name',
    icon: 'mdi-account-outline',
    errors: {
      required: 'User name is required',
    },
  },
  [EFieldNames.Password]: {
    label: 'Password',
    icon: 'mdi-lock-outline',
    type: 'password',
    errors: {
      required: 'Password is required',
    },
  },
};

export const studentLoginFieldsValidation = {
  [EFieldNames.UserName]: {
    required,
  },
  [EFieldNames.Password]: {
    required,
  },
};
